import React from "react";
import { FaEnvelope, FaPhone } from "react-icons/fa";

const ContactInfo = () => {
  return (
    <section className="bg-white py-5">
        <div className="text-center mb-5">
  <small
    className="text-uppercase font-weight-bold d-block mb-2"
    style={{ color: "var(--light-green-color)" }}
  >
    contact us
  </small>

  {/* <h2 className="position-relative d-inline-block">
    We’d Love to Hear From You
    <span className="heading-highlight" />
  </h2> */}
</div>
      <div className="container">

  {/* ======================= */}
  {/* COMMON TOP HEADERS ROW  */}
  {/* ======================= */}
  <div className="row mb-5 text-center text-lg-left">

    {/* Contact Us Header */}
    <div className="col-lg-6 mb-4 mb-lg-0">
      {/* <small
        className="text-uppercase font-weight-bold d-block mb-2"
        style={{ color: "var(--light-green-color)" }}
      >
        contact us
      </small> */}

      <h2 className="position-relative d-inline-block">
        Call us or leave a Message
        <span className="heading-highlight" />
      </h2>
    </div>

    {/* Reach Us Header */}
    <div className="col-lg-6 pl-lg-5">
      {/* <small
        className="text-uppercase font-weight-bold d-block mb-2"
        style={{ color: "var(--light-green-color)" }}
      >
        reach us
      </small> */}

      <h2 className="position-relative d-inline-block">
        Visit our Location
        <span className="heading-highlight" />
      </h2>
    </div>
  </div>

  {/* ======================= */}
  {/* CONTENT ROW             */}
  {/* ======================= */}
  <div className="row align-items-center">

    {/* LEFT – CONTACT CONTENT */}
    <div className="col-lg-6 mb-5 mb-lg-0">
      <div className="row align-items-center">
        <div className="col-md-5 text-center mb-4 mb-md-0">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2Fcontact-new.png?alt=media&token=b9d8f182-6ea5-44ab-8e8a-f9a5609a3250"
            alt="Contact"
            className="img-fluid"
            
          />
        </div>

        <div className="col-md-7">
          <div className="mb-2">
            <div className="text-uppercase font-weight-bold" style={{ color: "var(--light-green-color)" }}>
              Send Email
            </div>
            <div style={{ fontSize: "20px" }}>
              beyondlottotv@gmail.com
            </div>
          </div>

          {/* <div className="mb-2" >
            <div className="text-uppercase  font-weight-bold" style={{ color: "var(--light-green-color)" }}>
              georgia
            </div>
            <div className="d-flex align-items-center">
              <span style={{ fontSize: "20px", marginRight: "20px" }}>4047345448</span>
              <div className="d-flex">
                <span className="icon-circle mr-2"><FaEnvelope /></span>
                <span className="icon-circle"><FaPhone /></span>
              </div>
            </div>
          </div> */}

          <div className="mb-2">
            <div className="text-uppercase font-weight-bold" style={{ color: "var(--light-green-color)" }}>
              texas
            </div>
            <div className="d-flex align-items-center">
              <span style={{ fontSize: "20px", marginRight: "20px" }}>8323883526</span>
              <div className="d-flex">
                <span className="icon-circle mr-2"><FaEnvelope /></span>
                <span className="icon-circle"><FaPhone /></span>
              </div>
            </div>
          </div>
           <div className="mb-2">
            <div className="text-uppercase  font-weight-bold" style={{ color: "var(--light-green-color)" }}>
              Houston
            </div>
            <div className="d-flex align-items-center">
              <span style={{ fontSize: "20px", marginRight: "20px" }}>3464981097</span>
              <div className="d-flex">
                <span className="icon-circle mr-2"><FaEnvelope /></span>
                <span className="icon-circle"><FaPhone /></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* RIGHT – MAP */}
    <div className="col-lg-6 pl-lg-5">
      <div className="map-wrapper">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3465.454345456972!2d-95.5072838!3d29.706595699999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c352e02b23a1%3A0x6107a94a71f369b9!2sBEYOND%20-%20Lotto%20TV%2C%20CCTV%20Security%20%26%20LED%20Lighting%20Co!5e0!3m2!1sen!2s!4v1765465867547!5m2!1sen!2s"
          width="100%"
          height="250"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          title="Reach Us"
        />
      </div>
    </div>
  </div>
</div>

      {/* Styles */}
      <style>
        {`
          .heading-highlight {
            position: absolute;
            left: 50%;
            top: 80%;
            transform: translate(-50%, -50%);
            width: 65%;
            height: 60%;
            background-color: var(--light-green-color);
            opacity: 0.1;
            border-radius: 10px;
            z-index: -1;
          }

          .icon-circle {
            background: #ecf0ec;
            color: var(--light-green-color);
            height: 45px;
            width: 45px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }

          .map-wrapper iframe {
            border-radius: 12px;
          }

          @media (max-width: 768px) {
            .map-wrapper iframe {
              height: 300px;
            }
          }
        `}
      </style>
    </section>
  );
};

export default ContactInfo;
